import {
  useMutation,
  useQueryClient
} from "react-query";
import {FREQUENT_PASSAGE_STICKER_TYPES_ALL_QUERY_KEY} from "./useFrequentPassageStickerTypes";
import {
    updateFrequentPassageStickerType,
    UpdateFrequentPassageStickerTypeRequest
} from "../../../services/api/frequentPassageStickerTypes";

export const useUpdateFrequentPassageStickerTypes = () => {
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationFn: ({ id, data }: { id: number, data: UpdateFrequentPassageStickerTypeRequest }) => updateFrequentPassageStickerType(id, data),
      onError: (error, variables, context) => {
        console.error("ERROR ERROR ERROR", error);
      },
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(FREQUENT_PASSAGE_STICKER_TYPES_ALL_QUERY_KEY);
      }
    }
  );
};
